


































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { FETCH_CPT_CONFIGS, FETCH_SUBMISSIONS } from "@/store/actions-types";
import {
  GET_CPT_CONFIGS,
  GET_CPT_CONFIGS_LOADING,
  GET_SUBMISSIONS,
  GET_SUBMISSIONS_LOADING,
  GET_SUBMISSIONS_PAGINATION,
} from "@/store/getters-types";
import CreateUserBtnModal from "@/components/user-management/CreateUserBtn.vue";
import DeleteUserBtn from "@/components/user-management/DeleteUserBtn.vue";
import ChangePasswordBtn from "@/components/user-management/ChangePasswordBtn.vue";
import { CPTDataI } from "@/models/cpt/CPTModel";
import { CPTConfigModelI } from "@/models/admin/CPTConfigModel";
import DeleteSubmissionBtn from "@/components/submissions/DeleteSubmissionBtn.vue";
import { PaginationModelI } from "@/models/admin/PaginationModel";
import { SET_SUBMISSIONS_PAGINATION } from "@/store/mutations-types";
import StateBadge from "@/components/StateBadge.vue";
import { CPTState } from "@/models/cpt/CPTState";
import ModerateSubmissionBtn from "@/components/submissions/ModerateSubmissionBtn.vue";

@Component({
  components: {
    ModerateSubmissionBtn,
    StateBadge,
    DeleteSubmissionBtn,
    CreateUserBtnModal,
    DeleteUserBtn,
    ChangePasswordBtn,
  },
})
/**
 * Lists all submissions
 */
export default class Submissions extends Vue {
  /**
   * the selected nav entry
   */
  public selectedCptName = "";

  /**
   * indicate the current page of table
   */
  public currentPage = 1;

  /**
   * the table cols definitions
   */
  public tableFields = [
    {
      key: "title",
      label: this.$t("views.admin.submissions.title"),
      sortable: true,
      class: "overflow-hidden",
    },
    {
      key: "updated_at",
      label: this.$t("views.admin.submissions.updatedAt"),
      sortable: true,
    },
    {
      key: "state",
      label: this.$t("views.admin.submissions.state"),
      sortable: true,
    },
    { key: "actions", label: this.$t("views.admin.submissions.actions") },
  ];

  /**
   * load initial submissions and configs
   */
  async mounted(): Promise<void> {
    await this.$store.dispatch(FETCH_CPT_CONFIGS);
    this.selectedCptName = this.cptConfigs?.[0].name;
    await this.loadSubmissions();
  }

  /**
   * get submissions loading state
   */
  get getSubmissionsLoading(): boolean {
    return this.$store.getters[GET_SUBMISSIONS_LOADING];
  }
  /**
   * get config loading state
   */
  get getConfigLoading(): boolean {
    return this.$store.getters[GET_CPT_CONFIGS_LOADING];
  }

  /**
   * get all loaded submissions
   */
  get submissions(): CPTDataI[] {
    return this.$store.getters[GET_SUBMISSIONS];
  }

  /**
   * get pagination state
   */
  get pagination(): PaginationModelI {
    return this.$store.getters[GET_SUBMISSIONS_PAGINATION];
  }

  /**
   * get all cpt configs
   */
  get cptConfigs(): CPTConfigModelI[] {
    return this.$store.getters[GET_CPT_CONFIGS];
  }

  /**
   * watch current page and load it from api
   * @param currentPage
   */
  @Watch("currentPage")
  currentPageChange(currentPage: number): void {
    const pagination = this.$store.getters[GET_SUBMISSIONS_PAGINATION];
    pagination.current_page = currentPage;
    this.$store.commit(SET_SUBMISSIONS_PAGINATION, pagination);
    this.loadSubmissions();
  }

  /**
   * load filtered submissions
   */
  async loadSubmissions(): Promise<void> {
    if (!this.getSubmissionsLoading) {
      await this.$store.dispatch(FETCH_SUBMISSIONS, this.selectedCptName);
    }
  }
  /**
   * set the currently enabled cpt name
   * @param config
   */
  public onNavEntryClick(config: CPTConfigModelI): void {
    this.selectedCptName = config.name;
    this.loadSubmissions();
  }

  /**
   * define if a cpt can be deleted
   * @param state
   */
  public showDeleteBtn(state: string): boolean {
    return state === CPTState.PROPOSED || state === CPTState.PUBLISHED;
  }
}
